import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';
import { XY } from './V2.js';

export function line_hard(ia: XY[], res: number = 0.1): string {
    let output = "M ";
    for (let i = 0; i < ia.length; i++) {
        output += (ia[i].x * res) + " " + (ia[i].y * res) + " ";
    }
    if (ia.length == 1) output += "z ";
    return output;
}

export function lines_hard(ia: any[], res: number = 0.1): string {
    let output = "";
    for (let i = 0; i < ia.length; i++) {
        output += line_hard(ia[i], res);
    }
    return output;
}

export function shape_hard(ia: XY[], res: number = 0.1): string {
    if (ia.length == 0) return "";
    let output = "M ";
    for (let i = 0; i < ia.length; i++) {
        output += (ia[i].x * res) + " " + (ia[i].y * res) + " ";
    }
    return output + "z ";
}


export function dot(p: XY, res: number = 0.1, offset: XY = { x: 0, y: 0 }): string {
    return "M " + (p.x + offset.x) * res + " " + (p.y + offset.y) * res + " z ";
}

export function dots(ia: XY[], res: number = 0.1, offset: XY = { x: 0, y: 0 }) {
    let output = "";
    for (let i = 0; i < ia.length; i++) {
        output += dot(ia[i], res, offset);
    }
    return output;
}

export function svg_set(element: SVGPathElement, io: any) {
    for (const id in io) {
        if (id == "stroke_color") element.setAttributeNS(null, "stroke", io[id]);
        if (id == "color") element.setAttributeNS(null, "fill", io[id]);
    }
}

export type svg_manager_type = {
    list: (SVGPathElement | SVGSVGElement)[];
    get: (id: string) => SVGPathElement | SVGSVGElement;
    make_layer: (io?: any) => SVGSVGElement;
    make_line: (io: any) => SVGPathElement;
    make_shape: (io?: any) => SVGPathElement;
    make_circle: (io?: any) => SVGPathElement;
}

const name_space = "http://www.w3.org/2000/svg";

export function svg_manager(): svg_manager_type {

    const self = {

        list: [] as (SVGSVGElement | SVGPathElement)[],

        get: function (id: string) {
            return Arry.get.id(this.list, id);
        },

        make_layer: function (io: any = {}): SVGSVGElement {

            const { parent, id = Rndm.id(), res = 0.1, x = 0, y = 0, width = 0, height = 0 } = io;

            const svgElement = document.createElementNS(name_space, "svg");
            const e = svgElement as unknown as SVGSVGElement;

            e.id = id;

            e.style.transform = "translateX(" + (x * res) + "px) translateY(" + (y * res) + "px)";
            e.style.width = (width * res) + "px";
            e.style.height = (height * res) + "px";
            e.style.perspectiveOrigin = "right center";

            parent.appendChild(e);

            this.list.push(e);
            return e;
        },

        make_line: function (io: any) {

            const { parent, id = Rndm.id(), res, stroke = 0.01, cap = "butt", join = "bevel", d = "", color = "#ff00ff", rule = "nonzero", opacity = false, blend = "normal", rendering = "geometricPrecision", dash = false, filter = false } = io;

            const e = document.createElementNS(name_space, "path");
            e.id = id;

            e.setAttributeNS(null, "fill", "none");
            e.setAttributeNS(null, "d", d);
            e.setAttributeNS(null, "clip-rule", rule);
            e.setAttributeNS(null, "shape-rendering", rendering);
            e.setAttributeNS(null, "stroke", color);
            e.setAttributeNS(null, "stroke-width", String(stroke * res));
            e.setAttributeNS(null, "stroke-linecap", cap);
            e.setAttributeNS(null, "stroke-linejoin", join);

            if (dash) e.setAttributeNS(null, "stroke-dasharray", dash); //z. B. "4 1"
            if (filter) e.setAttributeNS(null, "filter", filter);
            if (blend) e.style.mixBlendMode = blend;
            if (opacity) e.style.opacity = opacity;

            parent.appendChild(e);
            this.list.push(e);
            return e;
        },

        make_shape: function (io: any = {}): SVGPathElement {

            const { parent, id = Rndm.id(), res, d = "", stroke, dash, color, stroke_color = color, cap = "round", join = "bevel", rule = "nonzero", rendering = "geometricPrecision", opacity = 1, blend = "normal", cursor = "auto", filter, pointer = "auto", click } = io;

            const svgElement = document.createElementNS(name_space, "path");
            const e = svgElement as unknown as SVGPathElement;

            e.id = id;

            (color) ? e.setAttributeNS(null, "fill", color) : e.setAttributeNS(null, "fill-opacity", "0");
            e.setAttributeNS(null, "d", d);
            e.setAttributeNS(null, "clip-rule", rule);
            e.setAttributeNS(null, "shape-rendering", rendering);

            if (stroke) e.setAttributeNS(null, "stroke-width", String(stroke * res));
            if (stroke) e.setAttributeNS(null, "stroke", stroke_color);
            if (stroke) e.setAttributeNS(null, "stroke-linecap", cap);
            e.setAttributeNS(null, "stroke-linejoin", join); //arcs | bevel |miter | miter-clip | round
            if (dash) e.setAttributeNS(null, "stroke-dasharray", dash); //z. B. "4 1"

            if (filter) e.setAttributeNS(null, "filter", filter);

            e.style.opacity = opacity;
            e.style.mixBlendMode = blend;
            e.style.cursor = cursor;
            e.style.pointerEvents = pointer;

            if (click) {
                e.onclick = click;
                e.addEventListener("touchend", (event) => { click(event) });
            }

            if (parent) parent.appendChild(e);

            this.list.push(e);
            return e;
        },

        make_circle: function (io: any = {}): SVGPathElement {

            const { parent, on_down, on_up, res, id = Rndm.id(), dash, size = 0.1, x = 0, y = 0, stroke = 0, color, stroke_color = color, rendering = "geometricPrecision", opacity = 1, blend = "normal" } = io;

            const e = document.createElementNS(name_space, "circle");
            e.id = id;

            color ? e.setAttributeNS(null, "fill", color) : e.setAttributeNS(null, "fill-opacity", "0");
            if (dash) e.setAttributeNS(null, "stroke-dasharray", dash); //z. B. "4 1"

            e.setAttributeNS(null, "cx", String(x * res));
            e.setAttributeNS(null, "cy", String(y * res));
            e.setAttributeNS(null, "r", String(size * res));
            e.setAttributeNS(null, "shape-rendering", rendering);
            e.setAttributeNS(null, "stroke-width", String(stroke * res));
            e.setAttributeNS(null, "stroke", stroke_color);

            e.style.opacity = opacity;
            e.style.mixBlendMode = blend;

            if (on_down) {
                e.addEventListener("pointerdown", (event: PointerEvent) => {
                    on_down(event);
                    event.preventDefault();
                }, { passive: false });
            }
            if (on_up) {
                e.addEventListener("pointerup", (event: PointerEvent) => {
                    on_up(event);
                    event.preventDefault();
                }, { passive: false });
            }

            if (parent) parent.appendChild(e);
            return e;
        }
    };
    return self;
}
